export enum ButtonVariants {
  PRIMARY = "primary",
  SECONDARY = "secondary",
  OPACITY_SECONDARY = "opacitySecondary",
  SIMPLE_SECONDARY = "simpleSecondary",
  GRAY = "gray",
  SHADOW_PRIMARY = "shadowPrimary",
  SHADOW_SECONDARY = "shadowSecondary",
}
